
//#region imports
import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";
import CategoryTranslationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryTranslationResponse";
import MeditationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/MeditationResponse";
import MeditationFilterModel from "@models/meditations/meditationFilterModel";
import CategoryViewModel from "@models/categoryViewModel";
import { Vue, Component, Inject } from "vue-property-decorator";
import { MEDIDATION_CREATE, MEDIDATION_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import { sortByLanguagePriority } from "@/utils/languagePriority";
//#endregion

@Component
export default class PageMeditationsComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: MeditationFilterModel = new MeditationFilterModel();
  columnNames = [
    "#",
    "Картинка",
    "Название",
    "Категории",
    "Рейтинг",
    "Комментарии",
    "Платная",
    "Дата",
    "Сон",
    "",
    "",
  ];
  createRouteName = MEDIDATION_CREATE;
  editRouteName = MEDIDATION_EDIT;
  categories: CategoryViewModel[] = [];
  currentMeditation: MeditationResponse = null;

  getDataFunc = this.$api.MeditationService.getMeditationsAsync.bind(
    this.$api.MeditationService
  );
  removeFunc = this.$api.MeditationService.deleteMeditationAsync.bind(
    this.$api.MeditationService
  );
  async created() {
    const items = (await this.$api.MeditationService.getCategoriesAsync())
      .Items;
    this.categories = (items || []).map((x) => new CategoryViewModel(x));
  }
  getCategoryName(meditation: MeditationResponse): string {
    const translations = meditation.Categories.reduce(
      (a: CategoryTranslationResponse[], b: CategoryResponse) => {
        return a.concat(b.Translations);
      },
      []
    );
    return sortByLanguagePriority(translations)
      .map((x) => `${x.LangCode}:${x.Name}`)
      .join("\n");
  }

  getAverageRating(meditation: MeditationResponse): number {
    return meditation.AverageRating.toFixed(1);
  }

  async startDelete(item: CategoryResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
